/**
 * Zod schemas for auth forms. Used by react-hook-form via @hookform/resolvers
 * and by tests to assert validation behaviour.
 *
 * The Cognito pool policy is a minimum of 6 characters with no character-class
 * requirements. We mirror it client-side so users see the error before submission.
 *
 * No confirm-code schema lives here: the Cognito pool auto-confirms
 * every signup via a PreSignUp Lambda, so the SPA never collects a
 * verification code.
 */
import { z } from 'zod';

const passwordPolicy = z.string().min(6, 'At least 6 characters');

export const SignupSchema = z.object({
  email: z.string().email('Enter a valid email'),
  password: passwordPolicy,
});

export const LoginSchema = z.object({
  email: z.string().email('Enter a valid email'),
  password: z.string().min(1, 'Password is required'),
});

export type SignupValues = z.infer<typeof SignupSchema>;
export type LoginValues = z.infer<typeof LoginSchema>;
